export default "__VITE_ASSET__8dDkCjlq__"